<h1 mat-dialog-title>Agregar nuevo campo</h1>
<mat-dialog-content>
  <mat-form-field>
    <input matInput [disabled]="false" placeholder="Nombre del Campo" [(ngModel)]="fieldName" name="fieldName" />
  </mat-form-field>
  <br>
  <mat-form-field>
    <mat-label>Tipo de Campo</mat-label>
    <mat-select required [(ngModel)]="fieldType" #selectType>
      <mat-option *ngFor="let fieldType of fieldTypes" [value]="fieldType.tipo_objeto_id">
        <mat-icon
          *ngIf="selectType.panelOpen">{{fieldType.tipo_objeto_icono}}</mat-icon>{{fieldType.tipo_objeto_nombre}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <br>
  <mat-slide-toggle color="primary" labelPosition="before" [(ngModel)]="fieldRequired">Requerido?</mat-slide-toggle>
  <br>
  <mat-form-field *ngIf="fieldType==2">
    <mat-label>Opciones</mat-label>
    <input required matInput placeholder="Opcion 1,Opcion 2" [(ngModel)]="fieldOptions" />
    <mat-hint align="left">Ingrese las opciones del campo separadas por comas</mat-hint>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)='createFieldForm()'>Aceptar</button>
  <button mat-raised-button (click)='closeMe()'>Cancelar</button>
</mat-dialog-actions>